import { count } from "rxjs";

export const ApiPaths = {
    auth:{
        base: '/auth',
        isEmailRegistered: (email:string) => {
            const encodedEmail = encodeURIComponent(email);
            return `/auth/isEmailRegistered/${encodedEmail}`
        },
        login: '/auth/login',
        sendOtpCode: (email:string) => {
            const encodedEmail = encodeURIComponent(email);
            return `/auth/send/otp/${encodedEmail}`
        },
        register: '/auth/Register',
        sendVerificationEmail:(email:string) =>{ 
            return `/auth/send/activation/${encodeURIComponent(email)}`},
        getSessionData: `/auth/session`,
        gettingActivated: (uuid: string, activationId: string) =>{
            const encodedUuid = encodeURIComponent(uuid);
            const encodedActivationId = encodeURIComponent(activationId);
            return `/auth/activate/user/${encodedUuid}/${encodedActivationId}`
        },
        rememberPassword: '/auth/reset/password' 
    },
    consents:{
        getByCountry: (country: string) => `/Consents/${country}`,
        getTermsAndPrivacy: (sessionCountry: string) => `/Consents/terms/privacy/${sessionCountry}`
    },
    veeva: {
        isEmailVeeva: (email:string) => `/veeva/by/email/${email}`
    },
    help:{
        countriesList: '/help/Countries',
        professionsList: '/help/Professions',
        countryConfigByCode: (countryCode: string) => `/help/country/config/${countryCode}`,
    },
};